import moment from 'moment-timezone';

import { optionalDecorator } from './funcUtils';

export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT = 'YYYY-MM-DD';
const TIME_FORMAT = 'HH:mm:ss';

export function fromServerDate(date) {
  if (!date) {
    return moment.invalid();
  }
  return moment(date, DATE_FORMAT).startOf('day');
}
export const fromServerDateOptional = optionalDecorator(fromServerDate);

function toServerDate(momentDate) {
  return momentDate.format(DATE_FORMAT);
}
export const toServerDateOptional = optionalDecorator(toServerDate);

export function fromServerTime(time) {
  if (!time) {
    return moment.invalid();
  }
  return joinDateAndTime(moment(), moment(time, TIME_FORMAT));
}
export const fromServerTimeOptional = optionalDecorator(fromServerTime);

function toServerTime(momentTime) {
  return momentTime.format(TIME_FORMAT);
}
export const toServerTimeOptional = optionalDecorator(toServerTime);

export function fromServerDateTime(datetime) {
  if (!datetime) {
    return moment.invalid();
  }
  return moment(datetime, DATE_TIME_FORMAT);
}
export const fromServerDateTimeOptional = optionalDecorator(fromServerDateTime);

export function isValidIanaZone(ianaCode) {
  return !!ianaCode && !!moment.tz.zone(ianaCode);
}

export function isValidUtcOffset(offset) {
  return typeof offset === 'string' && /^[+-]\d{2}:\d{2}$/.test(offset);
}

export function fromServerDateTimeAsLocal(datetime, ianaCode) {
  if (!datetime) {
    return moment.invalid();
  }
  if (!isValidIanaZone(ianaCode)) {
    return moment(datetime, DATE_TIME_FORMAT);
  }
  return moment.tz(datetime, DATE_TIME_FORMAT, ianaCode).local();
}

export function fromServerDateTimeWithOffsetAsLocal(datetime, offset) {
  if (!datetime) {
    return moment.invalid();
  }
  if (!isValidUtcOffset(offset)) {
    return moment(datetime, DATE_TIME_FORMAT);
  }
  return moment.parseZone(datetime + offset).local();
}

function toServerDateTime(momentDate) {
  return momentDate.format(DATE_TIME_FORMAT);
}
export const toServerDateTimeOptional = optionalDecorator(toServerDateTime);

export function now() {
  return moment();
}

/**
 * Strips time form date.
 */
export function toDate(datetime) {
  if (!datetime || !datetime.isValid()) {
    return moment.invalid();
  }
  return datetime.clone().startOf('day');
}

export function joinDateAndTime(date, time) {
  return time.clone().year(date.year()).month(date.month()).date(date.date());
}

export function forceDateIntoRange(value, { min, max }) {
  return moment.max(min, moment.min(value, max));
}

export function getValidDateRange(yearsBack) {
  return [
    now().subtract(yearsBack, 'years').startOf('year'),
    now().endOf('day'),
  ];
}

export function getSelectableYears(yearsBack) {
  const currentYear = now().year();
  return Array.from(
    { length: yearsBack + 1 },
    (_, i) => currentYear - yearsBack + i
  );
}

export function isWithinRange(date, { min, max }, granularity = 'day') {
  return (
    date.isValid() &&
    !date.isBefore(min, granularity) &&
    !date.isAfter(max, granularity)
  );
}

export function calculateDuration(date1, date2) {
  if (!date1 || !date2) {
    return moment.duration();
  }
  return moment.duration(date2?.clone().subtract(date1));
}
